/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureSubnets200ResponseSubnetsInner {
  /**
  * The name of the subnet
  */
  'name'?: string;
  /**
  * The full Azure resource ID
  */
  'id'?: string;
  /**
  * The address prefix (CIDR notation)
  */
  'addressPrefix'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "addressPrefix",
      "baseName": "addressPrefix",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureSubnets200ResponseSubnetsInner.attributeTypeMap;
  }

  public constructor() {
  }
}

